var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgMethodoTraitement(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 45 43",
    id: "svg23",
    className: "makeStyles-icon-41",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, "Methodo_Traitement") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId || "title2"
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    style: {
      fillRule: "revert"
    }
  }, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "TaxAnalytics_Desk_FEC_01",
    transform: "translate(-180.000000, -2050.000000)",
    stroke: "white"
  }, /*#__PURE__*/React.createElement("g", {
    id: "MISSION",
    transform: "translate(158.000000, 1698.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Methodo_Traitement",
    transform: "translate(23.000000, 353.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-22"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Stroke-20",
    d: "m 4.6323,13.642 h 8.604 z M 6.6821,9.5423 h 10.859 z m -2.0498,8.1993 h 6.885 z m 0,8.2002 h 6.885 z m 0,4.0996 h 9.199 z m 0,4.1006 h 14.26 z m 0,-12.2999 h 6.885 z M 16.852,14.7572 c 3.752,-3.752 9.837,-3.752 13.589,0 3.753,3.753 3.753,9.837 0,13.59 -3.752,3.752 -9.837,3.752 -13.589,0 -3.752,-3.753 -3.752,-9.837 0,-13.59 z m 24.899,21.5781 -7.129,-7.247 -3.451,3.508 7.129,7.248 z m -11.3096,-7.9883 2.391,2.431 z m 9.7051,9.75 2.534,2.576 z M 0,5.3451 H 5.344 V 1e-4 5.3451 Z M 26.4634,34.847 v 3.104 c 0,0.913 -0.739,1.652 -1.651,1.652 H 1.6514 c -0.912,0 -1.651,-0.739 -1.651,-1.652 V 4.41 L 4.4134,0 h 20.399 c 0.912,0 1.651,0.74 1.651,1.652 V 8.211 1.652 C 26.4634,0.74 25.7244,0 24.8124,0 H 4.4134 L 4e-4,4.41 v 33.541 c 0,0.913 0.739,1.652 1.651,1.652 h 23.161 c 0.912,0 1.651,-0.739 1.651,-1.652 z m 2.0312,-17.4013 -7.495,7.495 -2.928,-2.929 2.928,2.929 z"
  }))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMethodoTraitement);
export default __webpack_public_path__ + "static/media/Methodo_Traitement.a937f9744b6a060c2d77c81b70b18054.svg";
export { ForwardRef as ReactComponent };